import { render, staticRenderFns } from "./CustomerDetailsModal.vue?vue&type=template&id=5d64f149&"
import script from "./CustomerDetailsModal.vue?vue&type=script&lang=js&"
export * from "./CustomerDetailsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports